import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the Documents page heading and archive context.
     *
     * @datatask 895
     * @datataskName sp_ws_p2_w_documents_get
     * @param params Archive context for the page.
     * @returns The first page record returned by the procedure.
     */
    public async getDocuments(params: DocumentsParams): Promise<DocumentsGet> {
        return (await this.datatask.Post(895, params))[0];
    }

    /**
     * Retrieves list of documents matching the given query params.
     *
     * @datatask 309
     * @datataskName sp_ws_p2_documents_list
     * @param params the query params for the documents.
     * @returns promise containing list of documents.
     */
    public async getDocumentsList(params: GetDocumentsParams): Promise<DocumentItem[]> {
        return await this.datatask.Post(309, params);
    }
}

export interface DocumentItem {
    total_nbr_of_rows?: `${number}`;
    item_id: `${number}`;
    item_name: string;
    item_state: string;
    item_parms: string;
    item_path: string;
    custact_no: `${number}`;
    orderby: `${number}`;
    docfilename: string;
    extension: string;
    oleapplication_id: string;
    item_glyphicon: string;
    item_glyphicon_color: string;
    checksum: string;
    item_glyphicon_2: string;
    item_is_selected: '1' | '0';
    item_glyphicon_color_2: string;
    item_filtervalue: string;
    registered_by: string;
    registered_datetime: string;
    modified_datetime: string;
}

export interface DocumentsParams {
    argtype: string;
    argvalue: string;
}

export interface DocumentsGet {
    page_heading: string;
    argtype: string;
    argvalue: string;
}

export interface GetDocumentsParams {
    argtype: string;

    argvalue: string;

    searchtext: string;

    page_no?: number;

    /**
     * @default 'd'
     */
    doctype?: 'a' | 'd' | 'p' | 'v';

    /**
     * @default '0'
     */
    onlyFilenames?: '0' | '1';

    /**
     * @default '1'
     */
    glyphicon_select?: '1' | '0';

    /**
     * @default '0'
     */
    show_dateselector?: '1' | '0';

    /**
     * @default '1900-01-01'
     */
    date_fom?: string;

    /**
     * @default today 'yyyy-mm-dd' or if doctype === 'd' then '2999-12-12'
     */
    date_tom?: string;

    /**
     * @default 100
     */
    max_nbr_of_rows?: number | `${number}`;
}
